import { error } from '../../../core/js/utils/logger';

// TODO add checks for whether this category has a flag for swapping images on hover and

/**
 * Called by a saga to attach a hover event to the product tile face-out image
 * @param  {object} state The redux store
 * @return {undefined}    Returns nothing
 */
export function attachProductTileHover(state) {
    const isTouchDevice = _.get(state, 'core.deviceCharacteristics.is_touch', false);

    if (!isTouchDevice) {
        $(document).on('mouseenter mouseleave', '.js-product-tile-controls__link-wrap', (e) => {
            changeProductTileAltImg(e, state);
        });
    }
}

/**
 * Swaps a product's face-out image
 * @param  {object} e     The event object
 * @param  {object} state The redux store
 * @return {undefined}    Returns nothing
 */
export function changeProductTileAltImg(e, state) {
    const el = $(e.currentTarget).find('.js-product-tile-img');
    const tileImgSrc = el.attr('src');
    const tileAltImgSrc = el.attr('data-alt-src');

    if (!tileAltImgSrc || tileImgSrc === tileAltImgSrc) {
        return;
    }
    el.attr('src', tileAltImgSrc);
    el.attr('data-alt-src', tileImgSrc);
}

export function accordion(store) {
    accordionDefaultState(store);
    accordionToggle(store);
}

export function accordionDefaultState(store) {
    const parentTabset = $('.js-accordion-tabset');
    const tabPanel = $('.js-accordion-panel');

    $.each(parentTabset, function fn() {
        if ($(this).hasClass('is-collapsed')) {
            $(this).find(tabPanel)
                   .hide();
        }
    });
}

export function accordionToggle(store) {
    $('a.js-accordion-tab').on('touchend click', function fn(event) {
        event.preventDefault();

        const $el = $(this);
        const parentTabset = $el.closest('.js-accordion-tabset');
        const tabPanel = $el.next('.js-accordion-panel');

        if (parentTabset.hasClass('is-collapsed')) {
            parentTabset.removeClass('is-collapsed');
            parentTabset.addClass('is-expanded');
            tabPanel.show();
        } else if (parentTabset.hasClass('is-expanded')) {
            parentTabset.removeClass('is-expanded');
            parentTabset.addClass('is-collapsed');
            tabPanel.hide();
        }
    });
}

// Prevent Mobile Scrolling of element from overflowing to body.
// This is especially problematic in mobile safari with position fixed elements & rubberband/elastic scrolling
export function attachPreventMobileOverScroll(touchStartEvent, touchMoveEvent, eventSelector, scrollingElementSelector) {
    let lastY;

    if (!touchStartEvent || !_.includes(touchStartEvent, 'touchstart') || !touchMoveEvent
        || !_.includes(touchMoveEvent, 'touchmove') || !eventSelector || !scrollingElementSelector) {
        error('--- MISSING OR INCORRECT PARAMS FOR attachPreventMobileOverScroll ---');
        return;
    }

    $(document).on(touchStartEvent, eventSelector, (e) => {
        lastY = getTouchYPosition(e);
        const scrollEvent = setScrollEventVars(e, scrollingElementSelector);

        /* Never letting the user reach the very top or very bottom of the scroll element, by 1 pixel */
        if (scrollEvent.top <= 0) {
            scrollEvent.element.scrollTop(1);
        } else if (scrollEvent.currentScroll >= scrollEvent.totalScroll) {
            scrollEvent.element.scrollTop(scrollEvent.top - 1);
        }
    });

    $(document).on(touchMoveEvent, eventSelector, (e) => {
        const currentY = getTouchYPosition(e);
        const scrollEvent = setScrollEventVars(e, scrollingElementSelector);

        /* If the user is scrolling towards the top of the page, */
        /* and they are at the top of the page, prevent default in order to */
        /* avoid the scroll event overflowing onto the body */

        if (currentY > lastY && scrollEvent.top <= 0) {
            e.preventDefault();
            e.stopPropagation();

        /* If the user is scrolling towards the bottom of the page, */
        /* and they are at the bottom of the page, prevent default in order to  */
        /* avoid the scroll event overflowing onto the body */
        } else if (currentY < lastY && scrollEvent.currentScroll >= scrollEvent.totalScroll) {
            e.preventDefault();
            e.stopPropagation();
        }
        lastY = currentY;
    });
}

export function detachPreventMobileOverScroll(touchStartEvent, touchMoveEvent, eventSelector) {
    $(document).off(touchStartEvent, eventSelector);
    $(document).off(touchMoveEvent, eventSelector);
}

function getTouchYPosition(event) {
    const touchesEvent = _.get(event, 'originalEvent.touches', false);

    return Boolean(touchesEvent) && touchesEvent.length ? touchesEvent[0].pageY : event.pageY;
}

function setScrollEventVars(event, scrollingElementSelector) {
    let element = $(event.currentTarget).closest(scrollingElementSelector);

    if (!element.length) {
        element = $(event.currentTarget).find(scrollingElementSelector);
    }
    const top = element.scrollTop();

    return {
        element: element,
        top: top,
        totalScroll: element.prop('scrollHeight'),
        currentScroll: top + element.outerHeight(true)
    };
}

/**
 * Prepare a DOM event to be safely serialized
 * @param {Object} evt A DOM Event object with circular references
 * @return {Object} Representation of the DOM Event without circular references
 *                  (Node and Window refs are replaced by "Node" and "Window" strings)
 */
export const serializableEvent = _.partialRight(_.map, (v) => {
    if (v instanceof Node) {
        return 'Node';
    }
    if (v instanceof Window) {
        return 'Window';
    }
    return v;
});

/**
 * Used to trigger country select on load of forms to render proper state/providence field
 * @returns {undefined}    Returns nothing
 */
export function triggerCountrySelect() {
    const $selectCountryDropdown = $('select[name="country"]');

    if ($selectCountryDropdown.length) {
        const selectedCountryValue = $selectCountryDropdown.val();

        if (selectedCountryValue !== null) {
            $selectCountryDropdown.val(selectedCountryValue).trigger('change');
        }
    }
}

/**
 * Used to initialize remaining character countdown functionality on textareas
 * @returns {undefined}    Returns nothing
 */
export function initializeTextAreas() {
    if ($('.js-textarea-remain').length <= 0) {
        return;
    }

    const maxCharactersAllowed = $('.js-textarea').attr('data-max-count');
    let currentNumberOfCharacters = $('.js-textarea-remain').val();

    if (!currentNumberOfCharacters) {
        currentNumberOfCharacters = 0;
    } else {
        currentNumberOfCharacters = currentNumberOfCharacters.trim().length;
    }

    $('.js-textarea-remain').text(maxCharactersAllowed - currentNumberOfCharacters);
}

export default {
    attachProductTileHover: attachProductTileHover,
    changeProductTileAltImg: changeProductTileAltImg
};

/**
 * Used to capture multiple event listeners and apply logic to those events fired.
 * @param {Function} condition A function that gets access to eventsFired and does some logic on them.
 * @param {Number}  timeout Amount of ms the timer should wait.
 * @returns {Object}    initialized tracker object.
 */
export function pauseEventListeners(condition, timeout) {
    const tracker = {};

    /**
     * Get event types fired from tracker object in the form of an array.
     * @returns {Array} Array of event types fired.
     */
    tracker.getEventsFiredArray = function() {
        return Object.keys(this.eventsFired);
    }

    /**
     * Resume event listening and run condition on eventsFired then dispatches a 'resume-listening' event.
     * If no condition, fire 'resume-listening' event with all eventsFired during pause.
     * @returns {undefined}
     */
    tracker.resume = function() {
        this.isListening = false;

        // check to see if the tracker has events.
        const eventsFiredArray = this.getEventsFiredArray();

        if (!eventsFiredArray.length) { return; }

        if (this.condition) {
            const eventsToFire = this.condition(this.eventsFired, eventsFiredArray);
            document.dispatchEvent(new CustomEvent('resume-listening', {
                detail: {
                    tracker: { ...this },
                    eventsToFire,
                    eventsToFireArray: Object.keys(eventsToFire) || [],

                },
            }));
            return;
        }

        document.dispatchEvent(new CustomEvent('resume-listening', {
            detail: {
                tracker: { ...this },
                eventsToFire: this.eventsFired,
                eventsToFireArray: eventsFiredArray || [],
            },
        }));

    }

    /**
     * Remove eventsFired from tracker object
     * @returns {Object} return updated tracker object.
     */
    tracker.removeEvents = function() {
        this.eventsFired = {};
        return { ...this };
    }

    /**
     * Checks to see if tracker is listening
     * @returns {Boolean}
     */
    tracker.isTrackerListening = function() {
        return this.isListening;
    }

    /**
     * Add an event to tracker object.
     * @param {Event} e The event object from the listener
     * @param {Function} handler The functiont that should get invoked when this event is successful.
     * @returns {undefined}
     */
    tracker.addEvent = function(e, handler) {
        this.resetOrStartTimer();

        if (!this.eventsFired[e.type]) {
            this.eventsFired[e.type] = {
                type: _.get(e, 'type'),
                element: _.get(e, 'target'),
                handler: handler,
            }
        }
    }

    /**
     * Resets tracker timer, on first invocation a new timer will be started.
     * @returns {undefined}
     */
    tracker.resetOrStartTimer = function() {
        if (!this.isTrackerListening()) {
            this.isListening = true;
            this.timerReference = setTimeout(() => this.resume(), this.timeout);
            return;
        }
        clearTimeout(this.timerReference);
        this.timerReference = setTimeout(() => this.resume(), this.timeout);
    }

    /**
     * Returns the current state of the tracker
     * @returns {Object} current state of the tracker object
     */
    tracker.getTrackerState = function() {
        return { ...this };
    }

    tracker.condition = condition;
    tracker.timeout = timeout;
    tracker.eventsFired = {};
    tracker.timeReference = null;
    tracker.isListening = false;

    return tracker;
};
